











import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';
import { LabelSelectionApi } from '@eurogast/hub-client-typescript';
import { ProductSearchFilterDeserializer } from '@/services/ProductSearchFilterDeserializer';
import Store from '@/store';
import { Mutations } from '@/store/types';
import ConfirmationActionButton from '@/common/ConfirmationActionButton.vue';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component({
  components: {ConfirmationActionButton}
})
export default class AddAllEssencesToLabelSelectionButton extends Vue {

    @Prop({required: false, default: ''})
    public localSearchFilter: string;

    private labelSelectionApiService = ApiService.wrap(LabelSelectionApi);

    public async addAllItemsToLabelSelection() {
      MatomoEvents.forEssences.addAllItemsToLabelPrint.publish();
      const searchFilter = ProductSearchFilterDeserializer.parseSearchFilter(this.localSearchFilter);
      try {
        const skus = await this.labelSelectionApiService.addAllEssenceItemsToLabelPrint(
            ConfigService.getTenant(),
            ConfigService.currentCustomerId,
            searchFilter
        );
        skus.forEach((sku) => Store.commit(Mutations.LabelSelection.addSku, sku));
      } catch (e) {
        await ApiService.defaultErrorHandler(e);
      }
      (this.$refs.confirmationActionButton as ConfirmationActionButton).hideDialog();
    }
}
